import type { WorkspaceSettingsQuery } from "@src/__generated__/urql-graphql";
import { action, makeObservable, observable } from "mobx";

export class BmailBoxIntegrationStore {
  @observable.ref
  isIntegrationActive = false;

  constructor() {
    makeObservable(this);
  }

  @action.bound
  init(data: WorkspaceSettingsQuery) {
    this.isIntegrationActive = Boolean(data.workspaceSettings?.bmail_activated);
  }
}
